import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  acceptRejectPendingUsers,
  getAllUsers,
  getOrganizationUsers,
  getOrganizations,
  getPendingUsers,
  getUnassignedUsers,
  moveUsersToOrganization,
} from "./api";
import { Organization, User } from "./types";
import { InviteAction } from "types/types";

export const fetchOrganizations = createAsyncThunk(
  "admin/fetchOrganizations",
  async () => {
    const response = await getOrganizations();
    return (await response.json()) as { data: Organization[] };
  }
);

export const fetchOrganizationUsers = createAsyncThunk(
  "admin/fetchOrganizationUsers",
  async (organizationId: string) => {
    const response = await getOrganizationUsers(organizationId);
    return (await response.json()) as { data: User[] };
  }
);

export const moveUsers = createAsyncThunk(
  "admin/moveUsers",
  async ({
    currentOrganizationId,
    newOrganizationId,
    userIds,
  }: {
    currentOrganizationId: string;
    newOrganizationId: string;
    userIds: string[];
  }) => {
    const response = await moveUsersToOrganization(
      currentOrganizationId,
      newOrganizationId,
      userIds
    );
    return (await response.json()) as { data: User[] };
  }
);

export const fetchAllUsers = createAsyncThunk("admin/users", async () => {
  const response = await getAllUsers();
  return await response.json();
});

export const fetchUnassignedUsers = createAsyncThunk(
  "admin/unassignedUsers",
  async () => {
    const response = await getUnassignedUsers();
    return await response.json();
  }
);

export const fetchPendingUsers = createAsyncThunk(
  "admin/pendingUsers",
  async () => {
    const response = await getPendingUsers();
    return await response.json();
  }
);

export const handlePendingUsers = createAsyncThunk(
  "admin/handlePendingUsers",
  async ({
    invitationId,
    action,
  }: {
    invitationId: string;
    action: InviteAction;
  }) => {
    const response = await acceptRejectPendingUsers(invitationId, action);
    return await response.json();
  }
);
